namespace Nobox {
    
    @Serenity.Decorators.registerEditor()
    export class AsepEditor extends Serenity.Select2Editor<object, object> {

        constructor(hidden: JQuery) {
            super(hidden, null);
            this.addItem({ id: ",", text: "Comma ','" });
            this.addItem({ id: "\\", text: "Apostrophe '\\'" });
            this.addItem({ id: ".", text: "Period '.'" });
            this.addItem({ id: " ", text: "Space ' '" });
            this.addItem({ id: "", text: "None ''" });
        }
    }
}